import {
  iconComponents,
  iconList,
  iconSizeList,
  iconColors,
} from './config/icons';

export default {
  name: 'GcIcon',
  data() {
    return {
      className: 'gc__icon',
    };
  },
  components: {
    ...iconComponents,
  },
  props: {
    iconType: {
      type: String,
      default: iconList[0],
      validator: possibleIconType => iconList.includes(possibleIconType),
    },
    size: {
      type: String,
      validator: possibleSize => iconSizeList.includes(possibleSize),
      default: iconSizeList[0],
    },
    theme: {
      type: String,
      default: 'dark',
    },
  },
  computed: {
    iconColor() {
      return iconColors[this.theme] ? iconColors[this.theme] : iconColors.dark;
    },
  },
};
